export function CloseButton({ onClick }: { onClick: () => void }) {
  return (
    <button
      onClick={onClick}
      className="flex items-center justify-center shrink-0 opacity-60 hover:opacity-100 transition-opacity"
      style={{ width: 40, height: 40 }}
    >
      <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
        <path d="M3 3L11 11M11 3L3 11" stroke="var(--t-text)" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    </button>
  );
}
